
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class BlogRelatedPostsController extends Controller {

	static targets = [ "actions", "link", "list" ];

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I expand the truncated rendering of related blog post links.
	*/
	expand() {

		this.actionsTarget.classList.add( "m-related-posts__actions--hidden" );
		this.listTarget.classList.remove( "m-related-posts__list--truncated" );
		this.linkTargets[ 0 ].focus();

	}

}
